skrilla.controller('createChargebackCtrl', function ($scope, searchService, modalService, cacheService, currencyService, srefService) {
    $scope.currencies = currencyService.getCurrencies();
    $scope.user = cacheService.getObjectOrElse("user", modalService.dismissAll);
    $scope.request = {
        currency: $scope.user.fiatCurrency,
        userId: $scope.user.id
    }

    $scope.chargeBack = function(){
        modalService.confirm("Are you sure you'd like to create a charge back report against this user", function () {
            searchService.post(`chargeBacks`, $scope.request, "Charge back report created", true)
                .then(function(response){
                    srefService.go("chargebackReportDetails", {id: response.data})
                    modalService.dismissAll();
                });
        })
    }


});